// extracted by mini-css-extract-plugin
module.exports = {"cropper-holder":"CropModal_cropper-holder__UMZ0N"};